import { IntlFormatters } from 'react-intl';

const getModalHeading = (formatMessage: IntlFormatters['formatMessage']) =>
  formatMessage({ id: 'orderDetailsHeading' });

export default getModalHeading;
